// Generated by Melange

import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";

function of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.albumGain;
  const v$1 = x.albumPeak;
  const v$2 = x.trackGain;
  const v$3 = x.trackPeak;
  return {
    albumGain: v !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.float_of_json, v) : undefined,
    albumPeak: v$1 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.float_of_json, v$1) : undefined,
    trackGain: v$2 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.float_of_json, v$2) : undefined,
    trackPeak: v$3 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.float_of_json, v$3) : undefined
  };
}

function to_json(x) {
  return {
    albumGain: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.albumGain),
    albumPeak: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.albumPeak),
    trackGain: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.trackGain),
    trackPeak: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.trackPeak)
  };
}

export {
  of_json,
  to_json,
}
/* No side effect */
